/*
  Seções HALO Ficha topo e HALO Ficha técnica (sections/halo-ficha-topo.liquid e halo-ficha.liquid).
  As abas do topo mostram uma ficha por vez (a seção com id HaloFicha-<âncora>). Clique ou setas do
  teclado trocam a ficha; o endereço com #âncora (ex.: #band) abre a ficha dela, também quando o #
  muda. Ao trocar, o endereço passa a ter a âncora, sem rolar a página. No editor de tema, escolher
  um bloco de uma ficha escondida abre a aba dela.
*/
(function () {
  'use strict';

  if (window.haloFicha) return;
  window.haloFicha = true;

  function tabs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-halo-ficha-abas] [role="tab"]'));
  }

  function panels() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-halo-ficha]'));
  }

  function activate(anchor, opts) {
    var options = opts || {};
    var list = tabs();
    var target = list.filter(function (t) { return t.dataset.ancora === anchor; })[0];
    if (!target) return false;
    list.forEach(function (t) {
      var on = t === target;
      t.classList.toggle('is-ativa', on);
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
    });
    panels().forEach(function (p) {
      p.hidden = p.dataset.ancora !== anchor;
    });
    if (options.focus) target.focus();
    if (options.hash && window.history && history.replaceState) {
      history.replaceState(null, '', '#' + anchor);
    }
    return true;
  }

  function fromHash() {
    var hash = decodeURIComponent((window.location.hash || '').replace(/^#/, '')).toLowerCase();
    if (hash) activate(hash);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-halo-ficha-abas] [role="tab"]');
    if (tab) activate(tab.dataset.ancora, { hash: true });
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-halo-ficha-abas] [role="tab"]');
    if (!tab) return;
    var list = tabs();
    var i = list.indexOf(tab);
    var next = null;
    if (e.key === 'ArrowRight') next = list[(i + 1) % list.length];
    else if (e.key === 'ArrowLeft') next = list[(i - 1 + list.length) % list.length];
    else if (e.key === 'Home') next = list[0];
    else if (e.key === 'End') next = list[list.length - 1];
    if (!next) return;
    e.preventDefault();
    activate(next.dataset.ancora, { focus: true, hash: true });
  });

  window.addEventListener('hashchange', fromHash);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
  else fromHash();

  document.addEventListener('shopify:section:load', fromHash);

  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest && e.target.closest('[data-halo-ficha]');
    if (panel && panel.hidden) activate(panel.dataset.ancora);
  });
})();
